/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs */

const en__field__enum_additionalstudyinterests_study_southeast_asian_studies28 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages and Cultures of Southeast Asia`)
};

const de__field__enum_additionalstudyinterests_study_southeast_asian_studies28 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen und Kulturen Südostasiens`)
};

/**
* | output |
* | --- |
* | "Languages and Cultures of Southeast Asia" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_southeast_asian_studies28 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Southeast_Asian_Studies28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_southeast_asian_studies28(inputs)
	return de__field__enum_additionalstudyinterests_study_southeast_asian_studies28(inputs)
});
export { _field__enum_additionalstudyinterests_study_southeast_asian_studies28 as "_field__enum_additionalStudyInterests_STUDY_SOUTHEAST_ASIAN_STUDIES" }